import React, { Component } from 'react'
import {
    Row,
    Col,
} from "react-bootstrap";

export default class Timer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            minutes: this.props.minutes,
            seconds: this.props.seconds,
            enableTimer: this.props.enableTimer
        }
        this.Timer = this.Timer.bind(this);
    }

    componentDidMount() {
        this.Timer();
    }

    callForResend() {
        this.props.callForResend();
    }

    Timer() {
        if (this.props.enableTimer) {
            this.myInterval = setInterval(() => {
                const { seconds, minutes } = this.state

                if (seconds > 0) {
                    this.setState(({ seconds }) => ({
                        seconds: seconds - 1
                    }))
                }
                if (seconds === 0) {
                    if (minutes === 0) {
                        clearInterval(this.myInterval)
                        this.callForResend();
                    } else {
                        this.setState(({ minutes }) => ({
                            minutes: minutes - 1,
                            seconds: 59
                        }))
                    }
                }
            }, 1000)
        }
    }

    componentWillUnmount() {
        clearInterval(this.myInterval)
    }

    render() {
        const { minutes, seconds } = this.state
        let timerBody;
        if (this.state.enableTimer) {
            timerBody = <div>
                {minutes === 0 && seconds === 0
                    ? <div className="location-details-input" style={{ color: "red", marginTop:"5px"}}>Time&nbsp;expired&nbsp;please&nbsp;resend</div>
                    : <div className="location-details-input" style={{ marginTop:"5px", color: minutes == 0 && seconds <= 30 ? "red" : this.props.color? this.props.color : 'black' }}>Time&nbsp;Remaining:&nbsp;{minutes}:{seconds < 10 ? `0${seconds}` : seconds}</div>
                }
            </div>
        } else { timerBody = <div></div> }
        return (
            <div>
                {timerBody}
            </div>
        )
    }
}